import {slideUp, slideDown} from 'es6-slide-up-down';
import findAncestor from "./findAncestor";

export default () => {
    const accordions = document.querySelectorAll('[data-accordion]');
    const closeButtons = document.querySelectorAll('[data-acc-close-all]');
    for (const accordion of accordions) {
        const titles = accordion.querySelectorAll('[data-accordion-title]');
        for (const title of titles) {
            title.addEventListener('click', (e) => {
                e.preventDefault();
                const item = title.parentNode;
                const content = item.querySelector('[data-accordion-content]');
                if (item.classList.contains('active')) { // close this
                    slideUp(content);
                    item.classList.remove('active');
                } else {
                    // const activeSlides = accordion.querySelectorAll('.active[data-accordion-item]');
                    // for (const activeSlide of activeSlides) {
                    //     const activeContent = activeSlide.querySelector('[data-accordion-content]');
                    //     activeSlide.classList.remove('active');
                    //     slideUp(activeContent)
                    // }
                    slideDown(content);
                    item.classList.add('active');
                }
                return false;
            });
        }
    }

    for (const closeButton of closeButtons) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            const holder = findAncestor(closeButton, '[data-acc-holder]');
            const activeSlides = holder.querySelectorAll('.active[data-accordion-item]');
            for (const activeSlide of activeSlides) {
                const activeContent = activeSlide.querySelector('[data-accordion-content]');
                activeSlide.classList.remove('active');
                slideUp(activeContent)
            }
            return false;
        })
    }
}

